export const validateRequireUppercaseLetters = (value: string): boolean => {
  return value.toLocaleLowerCase() !== value;
};
